import React, { Component } from "react";

class MainHero extends Component {
  render() {
    const { event } = this.props;
    const pricing = event.prices;
    const prices = Object.keys(pricing);
    return (
      <div className="main-tickets bg-primary text-accent py-4 ">
        <div className="container mx-auto" style={{maxWidth: "100%"}}>
          <div className="flex items-stretch flex-wrap">
            {pricing && prices.map((v, k) => (
              <div
                key={k}
                className="w-full md:flex-1">
                <div
                  className={
                    k === (prices.length-1)
                      ? "block text-center"
                      : "block text-center border-r"
                  }
                >
                  <div className="font-normal text-xl">
                    {v} ticket{v > 1 ? "s" : ""} for
                  </div>
                  <div className="font-semibold text-2xl my-2">
                    ${pricing[v].price}
                  </div>
                  {event.is_active && event.web_enabled && +event.shopify_enabled !== 1 && (
                    <span
                      className="cursor-pointer inline-block no-underline bg-accent hover:bg-accent-dark text-primary font-bold py-3 px-6 rounded my-4 shadow-outline"
                    >
                      BUY NOW
                    </span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default MainHero;
